const TELEMETRY_DISABLED_ATTRIBUTE = 'data-telemetry-disabled';

// Rendered by base.html.twig on token preview responses, whose URL carries the preview token.
const isTelemetryDisabled = () => typeof document !== 'undefined'
    && document.documentElement !== null
    && document.documentElement.hasAttribute(TELEMETRY_DISABLED_ATTRIBUTE);

export { TELEMETRY_DISABLED_ATTRIBUTE };
export default isTelemetryDisabled;
